import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import { useSelector } from 'src/hooks'
import { ProgressBar } from './ProgressBar'
import { GradientText } from './StyledText'

type CommissionType = {
  title: string
  total: number
}

export type AffiliateBonusCardProps = {
  percent: number
  bonus: string
  earnedQV: string
  isEligible?: boolean
  commissions: CommissionType[]
  totalCommision: string
  onClick?: () => void
  pqvOutstanding: string
}

export const AffiliateBonusCard = (props: AffiliateBonusCardProps) => {
  const {
    percent,
    bonus,
    earnedQV,
    isEligible = true,
    totalCommision,
    onClick,
    pqvOutstanding,
    commissions,
  } = props

  const screenWidth = useSelector(state => state.window.width)
  const isMobile = screenWidth <= 428

  const montserratFont = 'Montserrat, san serif'
  const gradientText = {
    background: 'linear-gradient(74deg, #34E3DF 16.27%, #02AEEE 86.38%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  }

  const earnedPQVText = (
    <GradientText
      fontSize={isMobile ? '.725rem' : '.825rem'}
      color={gradientText.background}
    >
      {earnedQV}
    </GradientText>
  )
  const outstandingPQVText = (
    <GradientText fontSize={isMobile ? '.725rem' : '.825rem'} color="#575757">
      {pqvOutstanding}
    </GradientText>
  )

  return (
    <Flex
      onClick={() => isEligible && onClick?.()}
      cursor={isEligible ? 'pointer' : 'initial'}
      flexWrap="wrap"
      style={{
        borderRadius: '.5rem',
        boxShadow:
          '0px 0px 12px 0px rgba(0, 0, 0, 0.08), 0px 0px 4px 0px rgba(25, 234, 183, 0.10)',
        backdropFilter: 'blur(16px)',
        opacity: isEligible ? '1' : '.4',
      }}
    >
      <Flex
        width="100%"
        flexDirection="column"
        backgroundColor="#f8f8f8"
        alignItems="center"
        justifyContent="space-between"
      >
        <Flex
          width="100%"
          inset="x1_5"
          position="relative"
          flexDirection="column"
          rowGap="x1_5"
        >
          <Flex justifyContent="space-between">
            <Text
              type="body"
              content={`${bonus} Bonus`}
              lineHeight={1.3}
              style={{
                fontSize: isMobile ? '.875rem' : '16px',
                fontWeight: 600,
                fontFamily: montserratFont,
                color: '#404040',
              }}
            />
            <Icon name="info" color="#000" size={20} />
          </Flex>
          <ProgressBar percentage={percent} />
          <Flex justifyContent="space-between">
            <Text
              type="body"
              style={{
                fontSize: isMobile ? '.725rem' : '.825rem',
                fontWeight: 700,
                fontFamily: montserratFont,
                color: '#979797',
                whiteSpace: 'nowrap',
              }}
            >
              PQV Earned: {earnedPQVText}
            </Text>
            <Text
              type="body"
              style={{
                fontSize: isMobile ? '.725rem' : '.825rem',
                fontWeight: 700,
                fontFamily: montserratFont,
                color: '#979797',
                whiteSpace: 'nowrap',
              }}
            >
              PQV Left: {outstandingPQVText}
            </Text>
          </Flex>
        </Flex>
        {commissions.map((commisson, index) => (
          <Flex
            key={index}
            inset={{ horizontal: 'x1_5' }}
            width="100%"
            justifyContent="space-between"
            backgroundColor="#fff"
          >
            <Text
              type="body"
              style={{
                fontSize: isMobile ? '.725rem' : '.825rem',
                fontWeight: 500,
                fontFamily: montserratFont,
                color: '#404040',
                whiteSpace: 'nowrap',
              }}
              content={commisson.title}
            />
            <Text
              type="body"
              style={{
                fontSize: isMobile ? '.725rem' : '.825rem',
                fontWeight: 600,
                fontFamily: montserratFont,
                color: '#404040',
                whiteSpace: 'nowrap',
              }}
              content={`$${commisson.total}`}
            />
          </Flex>
        ))}
      </Flex>
      <Flex
        width="100%"
        justifyContent="space-between"
        inset={{ vertical: '.375rem', horizontal: '.5rem' }}
        style={{
          background:
            'linear-gradient(74deg, rgba(52, 227, 223, 0.70) 16.27%, rgba(2, 174, 238, 0.70) 86.38%), #FFF',
          borderBottomLeftRadius: 'inherit',
          borderBottomRightRadius: 'inherit',
        }}
      >
        <Text
          type="body"
          content={'Total'}
          style={{
            fontSize: isMobile ? '.725rem' : '.825rem',
            fontWeight: 600,
            fontFamily: montserratFont,
            color: '#fff',
          }}
        />
        <Text
          type="body"
          content={totalCommision}
          style={{
            fontSize: isMobile ? '.825rem' : '.925rem',
            fontWeight: 500,
            fontFamily: montserratFont,
            color: '#fff',
          }}
        />
      </Flex>
    </Flex>
  )
}
